import { forwardRef } from "react";

export const PrimaryButton = forwardRef(
  (
    { children, type = "submit", disabled, loading, onClick, className },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled || loading}
        onClick={onClick}
        className={
          "w-full h-[50px] rounded-[16px] focus:outline-none bg-[#0E51ED] hover:bg-[#0E51ED]/60 text-white font-headings-primary font-medium text-[18px] leading-6 disabled:opacity-60 active:scale-[.99] transition flex items-center justify-center gap-2" +
          (className ? ` ${className}` : "") +
          (disabled ? " cursor-not-allowed" : "")
        }
      >
        {loading && (
          <i className="bi bi-arrow-repeat animate-spin text-[18px]"></i>
        )}
        {loading ? "" : children}
      </button>
    );
  }
);
